import { createClient } from '@supabase/supabase-js';

// Supabase credentials
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://bshosimfjlunrwmwbgzt.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJzaG9zaW1mamx1bnJ3bXdiZ3p0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAwODkyNTMsImV4cCI6MjA3NTY2NTI1M30.0aB5XEnmoy5NqQrKH60bWDyanFaBTUg-ysHQvZRUEqY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Types for our database
export interface Project {
  id: string;
  user_id: string;
  name: string;
  description?: string;
  editor_data: {
    elements: any[];
    canvasWidth: number;
    canvasHeight: number;
    canvasOrientation?: 'portrait' | 'landscape';
    backgroundColor?: string;
  };
  html_template?: string;
  is_public: boolean;
  thumbnail_url?: string;
  created_at: string;
  updated_at: string;
}

export interface Database {
  public: {
    Tables: {
      projects: {
        Row: Project;
        Insert: Omit<Project, 'id' | 'created_at' | 'updated_at'>;
        Update: Partial<Omit<Project, 'id' | 'created_at' | 'updated_at'>>;
      };
    };
  };
}

